<template>
    <aside>
        <section v-if="!allCategory" class="byGenre">
            <div class="headline">{{ title }}</div>
            <ul>
                <li v-for="(genre, i) in genres" :key="i">
                    <a href="#" class="circleAvatarTile" @click.stop="search('genre', genre.id)">
                        <div class="img"><img :data-src="genre.full_image_path" class="lazyload"></div>
                        <div class="text">{{ genre.name_public }}</div>
                    </a>
                </li>
            </ul>
        </section>
        <section v-else class="byLocation">
            <div class="headline">すべてのジャンル</div>
            <ul>
                <li v-for="(category, i) in genres" :key="i">
                    <div v-if="!isHotel(category)" :class="{'expander genreExpander': category.children }">
                        <div v-if="category.children" class="title">
                            <div class="circleAvatarTile">
                                <div class="text">{{ category.name_public }}</div>
                            </div>
                        </div>
                        <a v-else class="title" href="#" @click.stop="search('genre', category.id)">
                            <div class="circleAvatarTile">
                                <div class="img"><img :data-src="src(category.image_url)" class="lazyload"></div>
                                <div class="text">{{ category.name_public }}</div>
                            </div>
                        </a>
                        <div class="content">
                            <ul>
                                <li v-for="(genre, j) in category.children" :key="j">
                                    <a href="#" @click.stop="search('genre', genre.id)">{{ genre.name_public }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </section>
        <!-- <section class="byLocation">
            <div class="headline">すべての地域</div>
            <ul>
                <li v-for="(island, i) in areas" :key="i">
                    <div :class="{'expander genreExpander': island.children }">
                        <div v-if="island.children" class="title">
                            <div class="circleAvatarTile">
                                <div class="img"><img :data-src="island.full_image_path" class="lazyload"></div>
                                <div class="text">{{ island.name_public }}</div>
                            </div>
                        </div>
                        <a v-else class="title" href="#" @click.stop="search('island', island.id)">
                            <div class="circleAvatarTile">
                                <div class="img"><img :data-src="island.full_image_path" class="lazyload"></div>
                                <div class="text">{{ island.name_public }}</div>
                            </div>
                        </a>
                        <div class="content">
                            <ul>
                                <li v-for="(area, j) in island.children" :key="j">
                                    <a href="#" @click.stop="search('area', area.id)">{{ area.name_public }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </section> -->
        <section v-if="isArticle" class="byLocation">
            <div class="headline">すべてのライター</div>
            <ul>
              <li v-for="(writer, i) in writers" :key="i">
                  <a :href="'/article/writer?id=' + writer.id" class="circleAvatarTile">
                      <div class="img"><img :data-src="src(writer.image_url)" class="lazyload"></div>
                      <div class="text">{{ writer.display_name }}</div>
                  </a>
              </li>
            </ul>
        </section>
    </aside>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'すべてのジャンル',
            required: false,
        },
        genres: {
            type: Array,
            required: true,
        },
        areas: {
            type: Array,
            required: false,
        },
        writers: {
            type: Array,
            required: false,
        },
        link: {
            type: String,
            required: true,
        },
        allCategory: {
            type: Boolean,
            required: false,
        },
        imagePath: {
            type: String,
            required: false,
        },
        isArticle: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {
            search_word: null
        }
    },
    mounted() {
        this.getParam()
    },
    methods: {
        getParam() {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            this.search_word = urlParams.get('search_word')
        },
        search(key, id) {
            const url = new URL(this.link)
            if (this.search_word) {
                url.searchParams.append('search_word', this.search_word)
            }
            if (key && id) {
                url.searchParams.append(key, id)
            }
            window.location.href = url
        },
        src(url) {
            if(url) {
                return this.imagePath + url
            } else {
                return '/img/aloco_img_2.svg'
            }
        },
        isHotel(category) {
            return (category.name_public) === 'ホテル'
        }
    },
}
</script>
<style>
.circleAvatarTile .img img {
    border-radius: 50%;
}
</style>
